import { render, staticRenderFns } from "./leyes.vue?vue&type=template&id=50c6fb40&scoped=true"
import script from "./leyes.vue?vue&type=script&lang=js"
export * from "./leyes.vue?vue&type=script&lang=js"
import style0 from "./leyes.vue?vue&type=style&index=0&id=50c6fb40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c6fb40",
  null
  
)

export default component.exports